import axios from 'axios';
export default class BannerService {
    // async getBannerList(typ, stat, sdate, edate) {
    //     return await axios
    //         .post(`/admin/banner`, {
    //             type: typ,
    //             status: stat,
    //             startDate: sdate,
    //             endDate: edate,
    //             // sortBy: 'id',
    //             // sortOrder: 'desc',
    //         })
    //         .then((res) => res.data.data.banners)
    //         .catch((err) => {
    //             if(err.statusCode==='401'){
    //                 window.location.href = '/login';
    //             }
    //         });
    // }
    async getBannerList(data) {
        return await axios .post('/api/v1/admin/banner/list', data);
    }
    async viewBanner(id) {
        return await axios.get(`/api/v1/admin/banner/details/${id}`).then((result) => result.data.result[0]);
    }
    async updateBanner(formdata) {
        return await axios.put(`/admin/banner/edit`, formdata).then((res) => res);
    }
}
